import { ShieldCheck, Truck, RotateCcw, Lock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  { icon: ShieldCheck, title: "Protective packaging", sub: "Carefully packed for the journey" },
  { icon: Truck, title: "Worldwide shipping", sub: "Tracked delivery" },
  { icon: RotateCcw, title: "30-day returns", sub: "Not weird enough? Send it back" },
  { icon: Lock, title: "Secure checkout", sub: "Powered directly by Shopify" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="border-t border-white/10 bg-void py-16">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08}>
            <div className="flex items-start gap-4" data-testid={`trust-item-${i}`}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-amber/40 text-amber">
                <item.icon className="h-5 w-5" />
              </span>
              <div>
                <h4 className="font-display text-sm font-bold uppercase tracking-wide text-ivory">
                  {item.title}
                </h4>
                <p className="mt-1 text-sm text-ivory/50">{item.sub}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
